import { useEffect } from "react";
import cookies from "js-cookie";
import { setOriginalUrl } from "../../utils/gtm";

const GTMSetOriginalUrl = () => {
  useEffect(() => {
    const windowLocation = window?.location || {};
    const {
      protocol = "",
      hostname = "",
      pathname = "",
      search = "",
    } = windowLocation;
    const currentUrl = `${protocol}//${hostname}${pathname}${search}`;
    const refUrl = document?.referrer;
    const prevUrl = localStorage.getItem("prevUrl");
    localStorage.setItem("prevUrl", currentUrl);

    const currentCookies = cookies.get("originalUrl");
    const currentSession = sessionStorage.getItem("originalUrl");
    const isSetCookies = (!refUrl && prevUrl !== currentUrl) || !currentCookies;
    const isSetSession = (!refUrl && prevUrl !== currentUrl) || !currentSession;

    if (isSetCookies) {
      cookies.set("originalUrl", currentUrl, { expires: 180 });
    }
    if (isSetSession) {
      sessionStorage.setItem("originalUrl", currentUrl);
    }

    setOriginalUrl({
      originalUrl: sessionStorage.getItem("originalUrl"),
    });
  }, []);

  useEffect(() => {
    const windowLocation = window?.location || {};
    const {
      protocol = "",
      hostname = "",
      pathname = "",
      search = "",
    } = windowLocation;
    const originalUrl = `${protocol}//${hostname}${pathname}${search}`;
    localStorage.setItem("prevUrl", originalUrl);
  });

  return null;
};

export default GTMSetOriginalUrl;
